<app-card
  *ngIf="!loading"
  title="Thank You For Your Order"
  data-qa-id="Shopper Approved Card"
  headerClasses="px-6 is-size-4 has-text-weight-bold card-header-title"
  contentClasses="card-body-background"
>
  <div id="outer_shopper_approved"></div>
</app-card>
